import React from "react";

export class GeneralPrivacyPolicyES extends React.Component {
    render() {
        return (
            <>
                <p>
                    Última actualización: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    Dedalus Medical System, una empresa del grupo Dedalus, concede una gran importancia y tiene la intención de prestar especial atención a la protección de sus
                    datos personales y al respeto de su privacidad.
                    <br />
                    <br />
                    El objetivo de esta política de privacidad y aviso de información para los usuarios del sitio web (en lo sucesivo, el "aviso") es, por lo tanto, informarle de
                    cómo se tratan sus datos personales cuando visita un portal DeepUnity PACSonWEB como, por ejemplo, secure.pacsonweb.com (en lo sucesivo, el "sitio").
                    <br />
                    <br />
                    En este contexto, tenga en cuenta que Dedalus actúa como controlador (responsable del tratamiento) de su información personal (en lo sucesivo, "nosotros", "nos"
                    y "nuestro").
                    <br />
                    <br />
                    Confirmamos expresamente que todos los datos personales se tratarán de conformidad con el Reglamento 2016/679, de 27 de abril de 2016, relativo a la protección
                    de las personas físicas en lo que respecta al tratamiento de datos personales. Esto es importante y le animamos a que se tome el tiempo necesario para leer
                    detenidamente esta política.
                </p>
                <h2>ÁMBITO DE APLICACIÓN DE LA PRESENTE POLÍTICA DE PRIVACIDAD</h2>
                <p>La presente política de privacidad se aplica</p>
                <ul>
                    <li>
                        a toda la información personal recopilada de los usuarios de la plataforma DeepUnity PACSonWEB. Esto incluye a todos los médicos, dentistas, especialistas,
                        ... que se registren y utilicen DeepUnity PACSonWEB a través de una cuenta, así como a los usuarios no registrados que abran una consulta utilizando el
                        número de referencia y la fecha de nacimiento.
                    </li>
                    <li>todos los términos y condiciones y demás políticas de DH Healthcare GmbH aplicables a los servicios prestados,</li>
                </ul>
                <p>
                    Esta política de privacidad no se aplica a los datos de pacientes procesados por DH Healthcare GmbH en nombre de hospitales y departamentos de radiología
                    vinculados. Esto incluye tanto los datos médicos generados por el departamento de radiología como los datos médicos puestos a disposición de un departamento de
                    radiología por el propio paciente a través de la funcionalidad de carga. Para ello, nos remitimos a la política de privacidad del departamento de radiología
                    correspondiente.
                </p>
                <h2>1. ¿QUÉ DATOS PERSONALES RECOPILAMOS?</h2>
                <p>
                    Cuando utilice nuestro portal, podemos recopilar las siguientes categorías de datos personales sobre usted:
                    <br />• datos de identificación (por ejemplo, apellidos, nombre, dirección de correo electrónico, nombre de usuario, contraseña, región, tipo de dispositivo).
                    <br />• datos profesionales (por ejemplo, puesto desempeñado, campo de actividad, empleador).
                    <br />• datos técnicos (por ejemplo, dirección IP, tipo de navegador utilizado, Hora de inicio de sesión en el portal, etc.); y
                    <br />• cualquier dato personal contenido en cualquier correspondencia que nos envíe.
                    <br />
                    <br />
                    El suministro de sus datos personales es voluntario, pero no podremos proporcionarle los servicios y la información que solicite sin él. Por ejemplo, si se
                    comunica con nosotros a través del sitio, deberá proporcionarnos su dirección de correo electrónico para que podamos responderle.
                    <br />
                    <br />
                    En cualquier caso, le informaremos cuando sea obligatorio facilitar sus datos personales.
                    <br />
                    <br />
                    Además, si nos facilita datos personales pertenecientes a terceros, se compromete a asegurarse de que dichas personas hayan sido debidamente informadas del
                    tratamiento de sus datos personales de acuerdo con esta política y, en su caso, hayan dado su consentimiento para el tratamiento de sus datos personales.
                </p>
                <h2>2. ¿POR QUÉ UTILIZAMOS SUS DATOS PERSONALES?</h2>
                <p>
                    La siguiente tabla describe los fines para los que tratamos sus datos personales y, para cada finalidad, la base legal para la operación de tratamiento en
                    cuestión:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALIDADES</th>
                            <th>BASE JURIDCA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registro de una cuenta de usuario con aplicación de los correspondientes métodos seguros de autenticación y autorización. Esto incluye, por ejemplo,
                                el envío de correos electrónicos o mensajes de texto para protocolos de autenticación de dos factores;
                            </td>
                            <td>El tratamiento se basa en su consentimiento.</td>
                        </tr>
                        <tr>
                            <td>Envío automático de correos electrónicos cuando un nuevo estudio está disponible para el usuario en DeepUnity PACSonWEB;</td>
                            <td>El tratamiento se basa en su consentimiento.</td>
                        </tr>
                        <tr>
                            <td>Trazabilidad del acceso registrado a la información médica;</td>
                            <td>El tratamiento es necesario para cumplir con las obligaciones legales a las que estamos sujetos.</td>
                        </tr>
                        <tr>
                            <td>
                                Suministro de la lista de usuarios registrados a los hospitales que utilizan DeepUnity PACSonWEB para su distribución. Esta lista sólo incluye
                                Apellido, Nombre y Número de identificación como médico (RIZIV, BIG, ...)
                            </td>
                            <td>El tratamiento se basa en nuestro interés legítimo de informar a nuestros clientes sobre el uso de los servicios prestados.</td>
                        </tr>
                        <tr>
                            <td>
                                Responder a las solicitudes y preguntas que pueda enviar a través del sitio y, en términos más generales, administrar nuestra relación con los
                                visitantes del sitio.
                            </td>
                            <td>Contrato</td>
                        </tr>
                        <tr>
                            <td>Mejorar nuestros servicios y nuestro sitio.</td>
                            <td>
                                El tratamiento se lleva a cabo de conformidad con nuestro interés legítimo, que implica optimizar nuestras herramientas y soluciones para adaptarse
                                mejor a los visitantes, clientes y prospectos de nuestro sitio.
                            </td>
                        </tr>
                        <tr>
                            <td>Cumplir con las obligaciones legales y reglamentarias que nos sean aplicables.</td>
                            <td>El tratamiento es necesario para cumplir con las obligaciones legales a las que estamos sujetos.</td>
                        </tr>
                        <tr>
                            <td>Gestionar cualquier disputa potencial o real con usted o terceros.</td>
                            <td>
                                El tratamiento se lleva a cabo de conformidad con nuestro interés legítimo, lo que implica defender nuestros intereses, incluso a través de acciones
                                legales.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Envío, utilizando medios automatizados (por ejemplo, correo electrónico, SMS, MMS, etc.) y no automatizados (por ejemplo, teléfono, correo
                                ordinario, etc.), mensajes de marketing y mensajes de contenido promocional relacionados con nuestras actividades, productos y servicios y los de
                                las otras empresas del grupo Dedalus (incluidos estudios de mercado, encuestas de satisfacción del cliente, información sobre seminarios web y
                                eventos) (marketing)
                            </td>
                            <td>El tratamiento se lleva a cabo solo en caso de que proporcione un consentimiento específico</td>
                        </tr>
                        <tr>
                            <td>
                                Compartir sus datos personales con las otras empresas del grupo Dedalus establecidas en nuestro país/ región, para permitirles enviarle, utilizando
                                medios automatizados (por ejemplo, correo electrónico, SMS, MMS, etc.) mensajes de marketing y mensajes de contenido promocional relacionados con
                                sus actividades, productos y servicios (incluyendo estudios de mercado, encuestas de satisfacción del cliente, información sobre seminarios web y
                                eventos) (sharing con fines de marketing)
                            </td>
                            <td>El tratamiento se lleva a cabo solo en caso de que proporcione</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    En cualquier caso, tenga en cuenta que no procesaremos sus datos personales para ninguna otra finalidad que sea incompatible con los fines mencionados
                    anteriormente.
                </p>
                <h2>3. ¿CON QUIÉN COMPARTIMOS SUS DATOS PERSONALES?</h2>
                <p>
                    En el contexto de nuestras operaciones de tratamiento, podemos comunicar sus datos personales a los siguientes destinatarios:
                    <br />• a nuestros proveedores de servicios, proveedores, agentes y contratistas, en la medida en que nos ayuden a llevar a cabo los fines establecidos en esta
                    política (por ejemplo, utilizamos proveedores de servicios de TI para alojar sus datos personales en nuestro nombre).
                    <br />• las demás entidades del Grupo Dedalus en que nos ayuden a llevar a cabo los fines establecidos en esta política
                    <br />• a los tribunales competentes, las autoridades públicas, las agencias gubernamentales y las agencias de aplicación de la ley (incluso cuando se nos exija
                    cumplir con las solicitudes legales o reglamentarias).
                    <br />
                    <br />
                    Independientemente del destinatario, solo les revelaremos sus datos personales sobre una base estrictamente necesaria y solo en la medida necesaria para cumplir
                    con los fines identificados en esta política.
                    <br />
                    <br />
                    No vendemos sus datos personales.
                </p>
                <h2>4. ¿TRANSFERIMOS DATOS FUERA DEL ESPACIO ECONÓMICO EUROPEO?</h2>
                <p>
                    Para todos los países dentro del Espacio Económico Europeo, los datos personales de salud procesados por DeepUnity PACSonWEB no se transfieren a ningún país
                    fuera de esta área.
                </p>
                <p>
                    En caso de que sus datos personales se transfieran fuera del Espacio Económico Europeo ("EEE"), nos aseguramos de que el nivel de protección que se le brinda a
                    sus datos personales no se vea afectado negativamente por dichas transferencias.
                </p>
                <p>Esto significa específicamente que cada una de las transferencias previstas se basa en uno de los siguientes mecanismos como mínimo:</p>
                <ul>
                    <li>
                        la existencia de una decisión de adecuación emitida por la Comisión Europea para el país al que se transfieren sus datos personales; o, alternativamente;
                    </li>
                    <li>la celebración de cláusulas contractuales tipo que reproduzcan los modelos adoptados por la Comisión Europea; o, alternativamente;</li>
                    <li>
                        la existencia de una exención relacionada con una de las situaciones específicas previstas exhaustivamente por el Reglamento General de Protección de Datos
                        2016/679 ("RGPD") (por ejemplo, cuando haya dado su consentimiento a dicha transferencia habiendo sido informado de la ausencia de garantías, cuando la
                        transferencia sea necesaria para la ejecución de un contrato celebrado entre ustedes y nosotros, cuando la transferencia sea necesaria para la celebración o
                        ejecución de un contrato celebrado en su interés entre nosotros y un tercero, o cuando la transferencia sea necesaria para el establecimiento, ejercicio o
                        defensa de nuestras reclamaciones legales, etc.).
                    </li>
                </ul>
                <h2>5. ¿DURANTE CUÁNTO TIEMPO CONSERVAREMOS SUS DATOS PERSONALES?</h2>
                <p>
                    Conservaremos sus datos personales durante no más tiempo del necesario para la finalidad del tratamiento en cuestión.
                    <br />
                    <br />
                    En otras palabras, esto significa que los períodos de conservación que aplicamos varían según la finalidad para la que tratemos los datos en cuestión. Por lo
                    tanto, la siguiente tabla indica, para cada finalidad, el período de conservación que se aplicará a sus datos personales:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALIDADES</th>
                            <th>PERÍODO DE CONSERVACIÓN</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registro de una cuenta de usuario con aplicación de los correspondientes métodos seguros de autenticación y autorización. Esto incluye, por ejemplo,
                                el envío de correos electrónicos o mensajes de texto para protocolos de autenticación de dos factores;
                            </td>
                            <td>
                                Los datos personales proporcionados en el contexto del registro de una cuenta se conservarán durante un período de 2 años tras el último intento de
                                inicio de sesión con éxito.
                            </td>
                        </tr>
                        <tr>
                            <td>Envío automático de correos electrónicos cuando un nuevo estudio está disponible para el usuario en DeepUnity PACSonWEB;</td>
                            <td>
                                Los datos personales proporcionados en el contexto del registro de una cuenta se conservarán durante un período de 2 años tras el último intento de
                                inicio de sesión con éxito.
                            </td>
                        </tr>
                        <tr>
                            <td>Trazabilidad del acceso registrado a la información médica;</td>
                            <td>10 años</td>
                        </tr>
                        <tr>
                            <td>
                                Suministro de la lista de usuarios registrados a los hospitales que utilizan DeepUnity PACSonWEB para su distribución. Esta lista sólo incluye
                                Apellido, Nombre y Número de identificación como médico (RIZIV, BIG, ...)
                            </td>
                            <td>
                                Los datos personales proporcionados en el contexto del registro de una cuenta se conservarán durante un período de 2 años tras el último intento de
                                inicio de sesión con éxito.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Envío, utilizando medios automatizados (por ejemplo, correo electrónico, SMS, MMS, etc.) y no automatizados (por ejemplo, teléfono, correo
                                ordinario, etc.), mensajes de marketing y mensajes de contenido promocional relacionados con nuestras actividades, productos y servicios y los de
                                las otras empresas del grupo Dedalus (incluidos estudios de mercado, encuestas de satisfacción del cliente, información sobre seminarios web y
                                eventos) (marketing)
                            </td>
                            <td>Procesaremos sus datos personales hasta que se retire su consentimiento</td>
                        </tr>
                        <tr>
                            <td>
                                Compartir sus datos personales con las otras empresas del grupo Dedalus establecidas en su país / región, para permitirles enviarle, utilizando
                                medios automatizados (por ejemplo, correo electrónico, SMS, MMS, etc.) mensajes de marketing y mensajes de contenido promocional relacionados con
                                sus actividades, productos y servicios (incluidos estudios de mercado, encuestas de satisfacción del cliente, información sobre seminarios web y
                                eventos) (sharing con fines de marketing)
                            </td>
                            <td>Procesaremos sus datos personales hasta que se retire su consentimiento.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    En cualquier caso, una vez transcurrido el período de conservación aplicable, borraremos o anonimizaremos sus datos personales para que ya no pueda ser
                    identificado.
                </p>
                <h2>6. ¿UTILIZAMOS COOKIES?</h2>
                <p>
                    Utilizamos cookies en nuestro sitio.
                    <br />
                    <br />
                    Para obtener más información sobre las cookies que utilizamos y los fines para los que las utilizamos, consulte nuestra política de cookies, que se puede
                    encontrar en la página de privacidad del sitio web.
                </p>
                <h2>7. ¿QUÉ DERECHOS TIENES?</h2>
                <p>
                    De acuerdo con el marco legal de protección de datos aplicable, en particular el RGPD, usted tiene los siguientes derechos como sujeto de datos:
                    <br />• Puede solicitar el acceso a sus datos personales y solicitar que se rectifiquen o borren.
                    <br />• También tiene derecho a solicitar que se limite el tratamiento de sus datos personales o a oponerse a los mismos.
                    <br />• Tiene derecho a la portabilidad de sus datos personales.
                    <br />• Cuando el tratamiento de sus datos personales se base en su consentimiento, tenga en cuenta que puede retirar su consentimiento en cualquier momento,
                    sin afectar la legalidad del tratamiento basado en su consentimiento realizado antes de revocar el mismo.
                    <br />
                    <br />
                    Sin embargo, tenga en cuenta que algunos de los derechos anteriores están sujetos a condiciones específicas dictadas por el marco legal de protección de datos
                    aplicable. Por lo tanto, si su situación específica no cumple con estas condiciones, desafortunadamente no podremos cumplir con su solicitud.
                    <br />
                    <br />
                    Para ejercer sus derechos, póngase en contacto con nuestro DPO utilizando los datos de contacto proporcionados en la Sección 8 (¿Cómo puede ponerse en contacto
                    con nosotros?). Para procesar su solicitud de la manera más eficiente posible, podemos solicitarle cierta información adicional para confirmar su identidad y /
                    o ayudar a localizar los datos personales que forman el objeto de su solicitud.
                    <br />
                    <br />
                    En cualquier caso, tenga en cuenta que puede presentar una reclamación ante la autoridad de control competente. Encontrará una lista de las autoridades de
                    protección de datos en https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm.
                </p>
                <h2>8. ¿CÓMO PUEDE PONERSE EN CONTACTO CON NOSOTROS?</h2>
                <p>
                    Si tiene alguna pregunta o solicitud con respecto a nuestras operaciones de tratamiento con sus datos personales en virtud de esta política, incluido el
                    ejercicio de sus derechos, como se describe anteriormente, puede contactarnos: du_pacsonweb@dedalus.eu
                    <br />
                    <br />
                    También hemos nombrado un delegado de protección de datos ("DPO"), con el que puede ponerse en contacto por correo electrónico en la siguiente dirección:
                    <br />
                    para Dedalus S.p.A. dpo.group@dedalus.eu
                    <br />
                    para Millennium S.r.l. dpo.millennium@dedalus.eu
                    <br />
                    para otras empresas con sede en Italia dpo@dedalus.eu
                    <br />
                    para empresas con sede en el Reino Unido dpo-uk@dedalus.group.
                    <br />
                    para empresas con sede en Francia dpo.france@dedalus.eu
                    <br />
                    para empresas con sede en Alemania/Austria y Suiza dpo.dach@dedalus.com
                    <br />
                    para DH Healthcare GmbH y otras empresas con sede en Bélgica dpo.belgium@dedalus.eu
                    <br />
                    para otras empresas dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
